import { render, staticRenderFns } from "./PerformanceCharts.vue?vue&type=template&id=1d717bf4&scoped=true"
import script from "./PerformanceCharts.vue?vue&type=script&lang=js"
export * from "./PerformanceCharts.vue?vue&type=script&lang=js"
import style0 from "./PerformanceCharts.vue?vue&type=style&index=0&id=1d717bf4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d717bf4",
  null
  
)

export default component.exports